module.exports = __webpack_public_path__ + "images/accents/accent-sl3-tables-391a3feb9f66dae852f7bc0b5a115ec5.webp";